import { render, staticRenderFns } from "./scroller.vue?vue&type=template&id=d2235092&"
import script from "./scroller.vue?vue&type=script&lang=js&"
export * from "./scroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports